import i18n, { i18n_t } from '@/locales/i18n';
const customLoadFunc = () => <t-loading text={i18n_t('加载中...')} size="small"></t-loading>;
export default customLoadFunc;
